<template>
    <el-dialog :title="evaluateInfo ? '评价' : '服务工单'" :visible="visibleOrder" width="50%" @close="closeDialog"
        :close-on-click-modal="false" append-to-body>
        <div class="container">
            <div class="fixed-cards">
                <!-- 商户报单详情的表单 -->
                <el-card v-if="declarationInfo" shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>商户报单信息:</span>
                    </div>
                    <div class="card-content">
                        <el-row>
                            <el-col :span="8"><strong>客户姓名:</strong> {{ declarationInfo.customName }}</el-col>
                            <el-col :span="8"><strong>客户手机号:</strong> {{ declarationInfo.customMobile }}</el-col>
                            <el-col :span="8"><strong>客户地址:</strong> {{ declarationInfo.customAddress }}</el-col>
                        </el-row>
                        <!-- 新增：故障现象 -->
                        <el-row>
                            <el-col :span="24">
                                <strong>故障现象:</strong> {{ declarationInfo.faultPhenomenon || '暂无' }}
                            </el-col>
                        </el-row>
                        <!-- 新增：故障照片 -->
                        <el-row v-if="declarationInfo.faultPhotos" class="fault-media-row">
                            <el-col :span="24">
                                <strong>故障照片:</strong>
                                <div class="fault-media-grid">
                                    <viewer :images="formmaterImage(declarationInfo.faultPhotos)">
                                        <img
                                            v-for="src in formmaterImage(declarationInfo.faultPhotos)"
                                            :src="src"
                                            :key="src"
                                            class="fault-media-item fault-photo"
                                        />
                                    </viewer>
                                    <span v-if="!formmaterImage(declarationInfo.faultPhotos).length">暂无图片</span>
                                </div>
                            </el-col>
                        </el-row>
                        <!-- 新增：故障视频 -->
                        <el-row v-if="declarationInfo.videoUrl" class="fault-media-row">
                            <el-col :span="24">
                                <strong>故障视频:</strong>
                                <div class="fault-media-grid">
                                    <video
                                        v-for="src in formmaterImage(declarationInfo.videoUrl)"
                                        :src="src"
                                        :key="src"
                                        class="fault-media-item fault-video"
                                        controls
                                        preload="metadata"
                                        poster="https://img.yzcdn.cn/vant/cat.jpeg"
                                    />
                                    <span v-if="!formmaterImage(declarationInfo.videoUrl).length">暂无视频</span>
                                </div>
                            </el-col>
                        </el-row>
                        <!-- 新增：是否过保 -->
                        <el-row>
                            <el-col :span="24">
                                <strong>是否过保:</strong>
                                {{ declarationInfo.overinsuredFlag === 'YES' ? '是' : declarationInfo.overinsuredFlag === 'NO' ? '否' : declarationInfo.overinsuredFlag === 'PENDING' ? '由工程师选择' : declarationInfo.overinsuredFlag }}
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>服务工单详情:</span>
                    </div>
                    <div class="card-content">
                        <el-row v-if="dynamicColumns.length > 0">
                            <el-col v-for="column in dynamicColumns" :key="column.id"
                                style="display: flex;align-items: center;text-align: center;"
                                :span="getSpan(dynamicColumns.length)">
                                <strong>{{ column.fieldName }}:</strong>
                                <span v-if="['input', 'checkbox', 'radio'].includes(column.inputType)">{{
                                    column.fieldValue }}</span>
                                <!-- 评分星级 -->
                                <span v-else-if="column.inputType === 'star'"
                                    style="display: flex;align-items: center;text-align: center;">
                                    <el-rate v-model="column.fieldValue" disabled></el-rate>
                                    <span>{{ column.fieldValue == '1' ? '差' : column.fieldValue == '2' ? '一般' :
                                        column.fieldValue == '3' ? '好' : column.fieldValue == '4' ? '很好' :
                                            column.fieldValue
                                                == '5' ? '非常好' : '' }}</span>
                                </span>
                                <span v-else><time>{{ column.fieldValue }}</time></span>
                            </el-col>
                        </el-row>
                        <el-row v-if="dynamicColumns.length === 0">
                            <el-col :span="24">
                                <p>暂无数据</p>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <!-- 考勤信息卡片 -->
            <div class="dynamic-cards" v-if="punchRecords && punchRecords.length > 0">
                <el-card shadow="hover" class="card attendance-card">
                    <div slot="header" class="clearfix">
                        <span><i class="el-icon-time"></i> 考勤信息</span>
                    </div>
                    <div class="attendance-info">
                        <el-table :data="punchRecords" style="width: 100%" border size="small">
                            <el-table-column label="打卡类型" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag :type="scope.row.punchType === 'ENTRANCE' ? 'success' : 'danger'" size="small">
                                        {{ scope.row.punchType === 'ENTRANCE' ? '进场' : '退场' }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="punchTime" label="打卡时间" width="180" align="center"></el-table-column>
                            <el-table-column label="打卡照片" align="center">
                                <template slot-scope="scope">
                                    <viewer :images="formmaterImage(scope.row.photo)" v-if="scope.row.photo">
                                        <img v-for="src in formmaterImage(scope.row.photo)" :src="src" :key="src" class="punch-photo" />
                                    </viewer>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="address" label="打卡地址" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.address || '-' }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="imageFields.length > 0">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>工单清单图片信息:</span>
                    </div>
                    <div class="form-row" v-for="column in imageFields" :key="column.id">
                        <p class="gap-line-border" v-if="column.inputType === 'img'">
                            <span class="nameStyle">{{ column.fieldName }}:</span>
                            <span class="gap-line"></span>
                            <span v-if="column.fieldValue">
                                <viewer :images="formmaterImage(column.fieldValue)">
                                    <img v-for="src in formmaterImage(column.fieldValue)" :src="src" :key="src"
                                        class="card-image" />
                                </viewer>
                            </span>
                            <span v-else>暂无图片</span>
                        </p>
                    </div>
                </el-card>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
import { getPunchRecords } from "@/api/work/attendance";
import { DIC } from "@/const/dic";
export default {
    name: "ViewServiceDiary",
    props: {
        visibleOrder: {
            type: Boolean,
            required: true,
        },
        orderId: {
            type: [String, Number],
            required: true,
        },
        orderType: {
            type: String,
            required: true, 
        },
        declarationInfo: {
            type: Object,
            default: () => ({}), // 默认值为一个空对象
        },
        evaluateInfo: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tableData: [], // 存放固定字段数据
            dynamicColumns: [], // 存放动态字段列数据
            imageFields: [], // 存放动态图片字段数据
            inputTypes: [], // 获取动态控件类型
            punchRecords: [], // 考勤打卡记录
            loadingPenalty: false, // 考勤数据加载状态
        };
    },
    created() {
        
        // 初始加载时如果 orderId 已经有值，调用 handleList
        if (this.orderId) {
            // 获取动态控件类型
            findDataSourceFields().then(res => {
                let data = JSON.parse(res.data);
                this.inputTypes = data;

                // 获取产品数据
                const orderId = this.orderId; // 假设产品ID通过路由参数传递
                if (orderId) {
                    this.fetchGoodsData(orderId);
                }
            }).catch(err => {
                this.$message.error('获取动态控件类型失败', err);
            });
        }

    },
    watch: {
        /**
         * 
         * @param newVal 
         * @description 监听 visibleOrder 的变化
         * @returns void
         */
        visibleOrder(newVal) {
            console.log('visibleOrder', newVal);

            console.log('declarationInfo', this.declarationInfo);

            if (newVal && this.orderId) {
                // 获取动态控件类型
                findDataSourceFields().then(res => {
                    let data = JSON.parse(res.data);
                    this.inputTypes = data;

                    // 获取产品数据
                    const orderId = this.orderId; // 假设产品ID通过路由参数传递
                    if (orderId) {
                        this.fetchGoodsData(orderId);
                    }
                }).catch(err => {
                    this.$message.error('获取动态控件类型失败', err);
                });
            }
        }
    },
    methods: {
        formatDate(timestamp) {
            if (!timestamp) return '';
            const date = new Date(timestamp);
            return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
        },
        /**
         *
         * @param orderId 工单ID
         * @description 获取工单考勤记录
         * @returns void
         */
        fetchPunchRecords(orderId) {
            this.loadingPenalty = true;
            this.punchRecords = [];
            getPunchRecords(orderId).then(res => {
                if (res.code == '200' && res.data) {
                    try {
                        this.punchRecords = JSON.parse(res.data);
                    } catch (e) {
                        this.punchRecords = [];
                    }
                } else {
                    this.punchRecords = [];
                }
            }).catch(() => {
                this.punchRecords = [];
            }).finally(() => {
                this.loadingPenalty = false;
            });
        },
        /**
         * 
         * @param orderId 工单ID
         * @description 获取工单数据
         * @returns void
         */
        fetchGoodsData(orderId) {
            const params = {
                id: orderId,
                code: this.evaluateInfo ? 'AFTER_SALES_EVALUATION' : 'AFTER_SALES_ORDER'
            };
            if(this.orderType =='GENERAL_AFTERMARKET'&&this.evaluateInfo){
                params.code = 'TYSHPJ'
            }
            // 获取工单考勤记录
            this.fetchPunchRecords(orderId);
            // 获取产品数据
            evaluateInfoView(params).then(res => {
                if (res.code == "200") {
                    const jsonData = JSON.parse(res.data); // 解析返回的 JSON 数据
                    // 将图片字段单独处理
                    const imageFields = jsonData.list.filter(item => item.inputType == '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.value
                    }));
                    this.imageFields = imageFields;
                    // 其他字段
                    const dynamicColumns = jsonData.list.filter(item => item.inputType != '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.dataType.word == 'star' ? parseInt(item.value) : item.value
                    }));
                    this.dynamicColumns = dynamicColumns;
                    console.log('this.dynamicColumns::: ', this.dynamicColumns);

                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).catch(err => {
                this.$message.error('获取数据失败', err);
            });
        },
        /**
         * 
         * @param length 
         * @description 动态计算每列的span值
         * @returns number
         */
        getSpan(length) {
            // 动态计算每列的span值
            return Math.floor(24 / Math.min(length, 3)); // 最多3列
        },
        /**
         * 
         * @param row 
         * @description 格式化图片字段
         * @returns Array
         */
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        /**
         * 
         * @param inputType 
         * @description 获取输入类型的名称
         * @returns string
         */
        getInputType(inputType) {
            const item = this.inputTypes.find(type => type.id == inputType);
            return item ? item.word : ''; // 返回输入类型的名称
        },
        /**
         * 
         * @param status 
         * @description 获取状态的名称
         * @returns string
         */
        getStatusLabel(status) {
            const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
            return statusItem ? statusItem.label : status;
        },
        /**
         * 
         * @description 关闭弹窗
         * @returns void
         */
        closeDialog() {
            this.punchRecords = [];
            this.$emit("update:visibleOrder", false);
        }
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}

.fixed-cards,
.dynamic-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.clearfix {
    font-weight: bold;
}

.gap-line-border {
    padding: 0 10px;
    border: 1px dashed #ccc;
}

.gap-line {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}

.nameStyle {
    font-weight: bold;
    line-height: 4px;
}

.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
}

.card:hover {
    transform: scale(1.01);
}

.dynamic-cards:last-child {
    margin-bottom: 30px;
}

.card-content {
    padding: 20px;
    font-family: fangsong;
    word-break: break-word;
    /* 自动换行 */
}

.card p {
    margin: 10px 0;
    line-height: 1.6;
    word-break: break-word;
    /* 自动换行 */
}

.card strong {
    color: #333;
}

.card .el-image {
    border-radius: 5px;
}

.card-image {
    width: 100px;
    height: 100px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.form-row p {
    flex: 1;
    min-width: calc(20% - 10px);
    /* 每行三个内容，减去间隙 */
    box-sizing: border-box;
    margin: 0;
}

.dynamic-cards .card {
    width: 100%;
}

.attendance-info {
    padding: 10px;
}

.punch-photo {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;
    margin: 5px;
}

.fault-media-row {
  margin-top: 10px;
  margin-bottom: 10px;
}
.fault-media-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 8px;
}
.fault-media-item {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
  background: #fafbfc;
  object-fit: cover;
}
.fault-photo {
  width: 100px;
  height: 100px;
}
.fault-video {
  width: 140px;
  height: 100px;
}
.fault-media-item:hover {
  transform: scale(1.08);
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
}
@media (max-width: 768px) {
  .fault-media-grid {
    gap: 8px;
  }
  .fault-photo, .fault-video {
    width: 80px;
    height: 60px;
  }
}
</style>